import { useState, useEffect } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import * as socketEvents from 'constants/socketEvents';
import socket from 'services/socket';

const useStyles = makeStyles(({ palette, zIndex }) => ({
  dialog: {
    zIndex: zIndex.tooltip + 1,
  },
  backdrop: {
    backgroundColor: palette.background.default,
  },
}));

export default function AlertConectouEmOutroLocal() {
  const classes = useStyles();
  const [conectouEmOutroLocal, setConectouEmOutroLocal] = useState(false);

  const handleClose = () => {
    window.location.href = process.env.REACT_APP_HOMEPAGE_AUTH_URL || '';
  };

  useEffect(() => {
    const handler = () => {
      setConectouEmOutroLocal(true);
    };

    socket.on(socketEvents.ON_CONECTOU_EM_OUTRO_LOCAL, handler);

    return () => {
      socket.off(socketEvents.ON_CONECTOU_EM_OUTRO_LOCAL, handler);
      setConectouEmOutroLocal(false);
    };
  }, []);

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={conectouEmOutroLocal}
      className={classes.dialog}
      BackdropProps={{ className: classes.backdrop }}
    >
      <DialogContent>
        <DialogContentText>
          Detectamos que o Tarelo já está aberto em outro local. Clique em
          &quot;Fechar&quot; para sair do Tarelo neste local.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}
